<template>
  <div class="description">
    <div 
      v-for="(item, index) in chartDataTurnOver.cities" 
      :key="index"
    >

      <div
        v-if="item.key == 'other'"
        @click.stop="showModal = true"
        class="d-inline-flex align-items-center"
        style="cursor: pointer"
      >
        <v-avatar
          tile
          v-bind:style="{'background-color':chartDataTurnOver.color[index % 11]}"
          size="20"
          class="mx-1"
        />
        {{item.value}}
        
        <v-dialog
          v-model="showModal"
          max-width="500"
        >
          <v-card>
            <v-toolbar dark color="primary">
              <v-toolbar-title>Thông tin doanh thu khác</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="showModal = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-simple-table>
                <thead>
                  <tr>
                    <th class="text-center" style="font-weight: 500">Tên địa phương</th>
                    <th class="text-center" style="font-weight: 500">Tỷ lệ</th>
                    <th class="text-center" style="font-weight: 500">Doanh thu</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in otherTurnOver" :key="item.name">
                    <td class="text-center">{{ item.text }}</td>
                    <td class="text-center">{{ item.percentage }}</td>
                    <td class="text-center">{{ item.revenue}}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
            
          </v-card>
        </v-dialog>
      </div>



      <div v-if="item.key != 'other'" class="d-inline-flex align-items-center">
        <v-avatar
          tile
          v-bind:style="{'background-color':chartDataTurnOver.color[index % 11]}"
          size="20"
          class="mx-1"
        />
        {{item.value}}
      </div>
      
    </div>
  </div>
</template>
<script>
export default {
  props: {
    otherTurnOver: {
      type: Array,
      default: () => ([])
    },
    chartDataTurnOver: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showModal: false
    }
  }
}
</script>